import type { PropsWithChildren } from "react";

import { Navigate, useLocation, useSearchParams } from "react-router";

import { useAuthContext } from "@/services/auth";

export const AppRouteGate = ({ children }: PropsWithChildren) => {
  const { hasToken } = useAuthContext();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  if (searchParams.get("error_description")) {
    return <Navigate to={`/sso/error${location.search}`} replace />;
  }

  // If user is not logged in, redirect to login page
  if (!hasToken) {
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }

  // Otherwise, render the route content
  return children;
};
